import styled from 'styled-components'
import { Progress } from 'antd';

export const MainContainer = styled.div`
  padding: 20px;
  width: 85vw;
  overflow-x: auto;
`;

export const TopDiv = styled.div`
	display: flex;
	justify-content: space-between;
  overflow-x: auto;
`;

export const SelectorContainer = styled.div`
	display: flex;
`;

export const Selector = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Header = styled.div`
  background-color: white;
  padding: 10px;
  width: 100%;
  border-radius: 7px;
  display:flex;
  justify-content : ${props=>props.active ? 'space-between':'center'};
  font-size: large;
  margin-top: 10px;
  margin-bottom: 5px;
`;

export const StatContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  margin-bottom: 5px;
`

export const StatBox = styled.div`
  background-color: white;
  border-radius: 5px;
  padding: 15px;
  width: 27vw;
  display: grid;
  grid-template-columns: 30% 70%;
  align-items: center;
  cursor: pointer;

  &:hover {
    background-color: #f0fffe;
  }
`

export const IconDiv = styled.div`
  display: flex;
  justify-content: center;
`

export const LabelDiv = styled.div`
  display: flex;
  flex-direction:column;
`

export const StatNumber = styled.div`
  font-size: large;
  color: black;
`

export const StatLabel = styled.div`
  font-size: 14px;
  color: grey;
`

export const RevenueCol = styled.div`
  display: flex;               
  justify-content: flex-end;   
  align-items: center;         
  column-gap: 4px; 
`;

export const GraphContainer = styled.div`
  display: grid;
  grid-template-columns: 60% 2% 38%; 
  height: 38vh;
  margin: 10px 0;
`;

export const BarGraphContainer = styled.div`
  display: grid;
  grid-template-columns: 49% 2% 49%; 
  height: 38vh;
  margin: 10px 0;
`;

export const LeadGraphContainer = styled.div`
  display: grid;
  grid-template-columns: 100%; 
  height: 38vh;
  margin: 10px 0;
`;

export const GraphDiv = styled.div`
  background-color: white;
  padding: 10px;
  border-radius: 5px;  
  gap: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
`;

export const GraphDivLabelDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
`;

export const LabelHeading = styled.div`
  font-size: 15px;
  color: #02475c;
`;

export const GraphMonthSelector = styled.div`
  padding: 7px;
  border-radius: 5px;
  border: 1px solid whitesmoke;
  font-size: 12px;
  color: grey;
`;

export const SportsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 20px;
  text-align: center;
  margin: 10px;
`
export const SportsTab = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  gap: 10px;
  cursor: pointer;
  color: #02475c;
  background-color: ${props=>props.active ? '#e0f1f5' : '#fff'};
  border: ${props=>props.active ? '1px solid #02475c' : '1px solid #ddd'};

  &:hover {
    background-color: ${props=>props.active ? '#d3e9ef' : '#f1f1f1'};
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
  }
`

export const Icon = styled.a`
  cursor: pointer;
  color: grey;
  font-size: large;

  &:hover {
    color: #02475c;
    font-weight: bold; 
    transition: transform 0.3s ease;
  }
`;
export const StyledProgress = styled(Progress)`
  .ant-progress-text {
    fill: #FFFFFF;
    color: #FFFFFF;
    font-weight: bold;
  }
`;

export const CardDiv = styled.div`
  background-color: white;
  width: 49%;
  display: flex; 
  flex-direction: column; 
  padding-bottom: 20px ;
`

export const CardHeader = styled.div`
  background-color: #a8dada;
  color: #02475c; 
  display: flex; 
  align-items: center; 
  justify-content: space-between; 
  padding: 20px;
`
export const ProgressHeader = styled.div`
  display: flex; 
  justify-content: space-between;
  align-items: center;
  color: #02475c;
`

export const PieDiv = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const PieDivInfo = styled.div`
  justify-content: center;
  display: flex;
  flex-direction: column;
`;

export const InfoRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  
`;

export const InfoColor = styled.span`
  width: 15px;
  height: 15px;
  margin-right: 10px;
`;

export const InfoLabel = styled.div`
  font-size: 13px;
`;

export const TotalAmount = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const GraphDivRight = styled.div`
  background-color: white;
  padding: 15px;
  border-radius: 5px;
  height: 40vh;
  flex-direction: column;
  position: relative;
`;

export const GraphDivLeft = styled.div`
  background-color: white;
  padding: 15px;
  border-radius: 5px;
  height: 40vh;
`;

export const PipelineGraphDiv = styled.div`
  display: grid;
  grid-template-columns: 60% 2% 38%;
  margin: 10px 0;
  height: 40vh;
`;